import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Moment from 'moment';
import {
  Row,
  Col
} from 'react-bootstrap';
import { ObjToParam } from 'helper/helper-api';
import TableList from 'components/TableList';
import { Popup } from '../../components/Popup/popup';
import { CheckBox } from 'components/checkboxes/check-box';
import * as LotActionType from '../constants';
import { AppSettings } from '../../constants';

const defaultParams = {
  defaultSortName: 'refNo',
  defaultSortOrder: 'descending',
  sizePerPage: 100
};

class ManageRFSLot extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    LotStore: PropTypes.object,
    lotId: PropTypes.any
  }

  constructor(props) {
    super(props);
    this.statusList = ['New', 'Open', 'Declined', 'Closed'];
    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      sizePerPage: props.LotStore.ManageRFSLot.params.take,
      totalRecord: props.LotStore.ManageRFSLot.params.totalRecord,
      isShowPopup: false,
      selectedStatus: this.statusList,
      data: []
    };
  }

  componentDidMount() {
    const params = {
      id: this.props.lotId,
      param: this.objToParams(this.props.LotStore.ManageRFSLot.params)
    };
    this.bindingRFS(params);
    const self = this;
    window.addEventListener('click', (e) => {
      if (document.getElementById('s1-popup') && document.getElementById('s1-popup').contains(e.target)) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (document.getElementById('popup-button') && document.getElementById('popup-button').contains(e.target)) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({isShowPopup: false});
          }
        }

      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.LotStore.ManageRFSLot.items) {
      this.setState({
        data: nextProps.LotStore.ManageRFSLot.items,
        sizePerPage: nextProps.LotStore.ManageRFSLot.params.take,
        totalRecord: nextProps.LotStore.ManageRFSLot.params.totalRecord
      }, () => {
        setTimeout(() => {
          this.setState({
            data: nextProps.LotStore.ManageRFSLot.items
          });
        }, 100);
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: LotActionType.RESET_RFS_LOT
    });
  }

  bindingRFS(params) {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfile();
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(item => item.lot.id === this.props.lotId);
        if (lotFound) { this.onBindingRFSLot(lotFound.builderProfile, params); }
        else { this.onGetBuilderProfile(params); }
      }
    } else {
      this.props.dispatch({
        type: LotActionType.SEARCH_RFS_LOT_ASYNC,
        params
      });
    }
  }

  onGetBuilderProfile = (params) => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {lotId: this.props.lotId},
      callbackGetBuilderProfile: (builderProfile) => {this.onBindingRFSLot(builderProfile, params);}
    });
  }

  onBindingRFSLot = (builderProfile, params) => {
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: LotActionType.SEARCH_HOMEOWNER_RFS_LOT_ASYNC,
      params: {
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        lotId: params.id,
        param: params.param,
        isHomeowner: this.onCheckHomeownerOrTenancy(this.props.lotId)
      }
    });
  }

  onCheckHomeownerOrTenancy = (lotProfileId) => {
    let isHomeowner = true;
    if (AppSettings.clientTypeValue === 'Homeowner') {
      const lotFound = this.props.LotStore.HomeownerLots.find(item => item.lot.id === lotProfileId);
      if (lotFound && !lotFound.owner) { isHomeowner = false; }
    }
    return isHomeowner;
  }

  onTogglePopupFilter = () => {
    this.setState({ isShowPopup: !this.state.isShowPopup });
  }

  handleChangeStatusFilter = (e, value) => {
    if (this.state.selectedStatus.includes(value)) {
      this.setState({
        selectedStatus: [...this.state.selectedStatus.filter(item => item !== value)]
      }, () => {
        this.onChecked(e, this.state.selectedStatus);
      });
    } else {
      this.setState({
        selectedStatus: [...this.state.selectedStatus, value]
      }, () => {
        this.onChecked(e, this.state.selectedStatus);
      });
    }
  }

  onChecked = (e, data) => {
    if (data.length) {
      var params = this.objToParams(this.props.LotStore.ManageRFSLot.params);
      this.bindingRFS({
        id: this.props.lotId,
        param: {
          ...params,
          status: data.toString().toLowerCase(),
          skip: 0
        }
      });
    } else {
      this.setState({ data: [] });
    }
  }

  objToParams(obj) {
    return {
      searchKey: this.search ? this.search.value.trim() : '',
      sortField: obj.sortField,
      sortOrder: obj.sortOrder,
      skip: obj.skip - 1,
      take: obj.take
    };

  }

  refreshList(params) {
    this.setState({
      defaultSortName: params.defaultSortName,
      defaultSortOrder: params.defaultSortOrder,
      sizePerPage: params.sizePerPage
    }, () => {
      const data = {
        id: this.props.lotId,
        param: {
          searchKey: '',
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder,
          skip: params.currentPage - 1,
          take: params.sizePerPage,
          status: this.state.selectedStatus.toString()
        }
      };
      this.bindingRFS(data);
    });
  }

  customRenderRefNo = (item) => {
    if (this.onCheckHomeownerOrTenancy(this.props.lotId)) {
      return <Link to={`/${item.isPunchList ? 'punch-lists' : 'request-for-services' }/${item.refNo}`}>{item.refNo}</Link>;
    } else {
      return <span>{item.refNo}</span>;
    }
  }

  customRenderWONo = (item) => {
    return <Link to={`/request-for-services/work-order/detail/${item.refNo}/${item.wokOrderRefNo}`}>{item.wokOrderRefNo}</Link> 
  }

  customRenderCreatedDate = (item) => {
    return <span>{Moment(item.createdDate).format('MM/DD/YYYY')}</span>;
  }

  onClickNewRFS = () => {
    const { LotProfile } = this.props.LotStore;
    const params = {
      isFromLot: true,
      lotId: LotProfile.id,
      lotNumber: LotProfile.name,
      coe: LotProfile.coe,
      streetAddress: LotProfile.streetAddress,
      projectId: LotProfile.projectId,
      projectName: LotProfile.projectName
    };
    this.props.history.push(`/request-for-services/add?${ObjToParam(params)}`);
  }

  renderButtonNew = () => {
    if (AppSettings.clientTypeValue === 'Builder') {
      return <button
        className='btn btn-primary btn-info btn-siteone pull-left btn-icon'
        onClick={this.onClickNewRFS}>NEW</button>;
    }
    if (this.onCheckHomeownerOrTenancy(this.props.lotId)) {
      return <Link className='btn btn-primary btn-info btn-siteone pull-left btn-icon' to={`/lot/${this.props.lotId}/request/add`}>NEW</Link>;
    }
    return null;
  }

  render() {
    const data = this.state.data;
    let column ;
    if (AppSettings.clientTypeValue === 'Homeowner') {
     column = [
      { field: 'refNo', header: 'RFS#', hidden: false, isKey: true, sort: true, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderRefNo.bind(this) },
      { field: 'workOrder', header: 'WO#', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderWONo.bind(this) },
      { field: 'createdDate', header: 'Created', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderCreatedDate.bind(this) },
      { field: 'requestTypeName', header: 'Request type', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left' },
      { field: 'managedByUserName', header: 'Managed by', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left' },
      { field: 'numberOfWOs', header: '# of WOs', hidden: false, isKey: false, sort: false, dataAlign: 'center', headerAlign: 'center' },
      { field: 'statusValue', header: 'Status', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left' }
    ];
  }else{
     column = [
      { field: 'refNo', header: 'RFS#', hidden: false, isKey: true, sort: true, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderRefNo.bind(this) },
      { field: 'createdDate', header: 'Created', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderCreatedDate.bind(this) },
      { field: 'requestTypeName', header: 'Request type', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left' },
      { field: 'managedByUserName', header: 'Managed by', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left' },
      { field: 'numberOfWOs', header: '# of WOs', hidden: false, isKey: false, sort: false, dataAlign: 'center', headerAlign: 'center' },
      { field: 'statusValue', header: 'Status', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left' }
    ];
  }

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: this.state.totalRecord
    };

    const customHeader = (
      <div className='table-header'>
        <Row>
          <Col sm={12} md={12} className='text-right'>
            <div className='manage-user-filter pull-right'>
              <button id='popup-button' onClick={this.onTogglePopupFilter} className='btn btn-secondary fa fa-filter btn-icon' />
              {this.state.isShowPopup &&
                  <Popup ref={(ref) => { this.popup = ref; }}>
                    {this.statusList.map(item => {
                      return <CheckBox
                        checked={this.state.selectedStatus.indexOf(item) !== -1}
                        name='status'
                        value={item}
                        key={item}
                        label={item}
                        handleChange={this.handleChangeStatusFilter} />;
                    })}
                  </Popup>
              }
            </div>
          </Col>
        </Row>
      </div>
    );

    return <div id='manage-user' style={{padding: '0 35px'}}>
      <div className='page-title clearfix'>
        {this.renderButtonNew()}
      </div>

      <TableList
        column={column}
        defaultParams={defaultParams}
        data={data}
        options={options}
        refreshPageList= {this.refreshList.bind(this) }
        refreshList={ this.refreshList.bind(this) }
        pagination={false}
        customTableHeader={customHeader}
      />
    </div>;
  }
}

const mapStateToProps = (state) => {
  return {
    LotStore: state.LotStore
  };
};

export default connect(mapStateToProps)(ManageRFSLot);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-view-rfs-list.js